<template src="./TarjetaDescargar.html"></template>

<script>
import { leerArchivo } from  "../../../apiService/request/CrudDocumentos";
import Icono from "../../Icono/Icono";
import moment from "moment";
moment.locale('es');
  export default {
    name: "TarjetaDescargar",
    data() {
      return {
        banderaConsultando: false
      }
    },
    mounted(){
      // console.log('documentos', this.documentos)
    },
    props:{
      documentos: {
        type: Array,
        default: () => []
      }
    },
    filters: {
      formatoFechaHora: function (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a');
      }
    },
    methods: {
      async visualizarDocumento(docId) {
        try {
          this.banderaConsultando = true;
          const respuesta = await leerArchivo({
            docId
          })
          if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.url) {
            window.open(respuesta.data.data.url);
          } else {
            console.log('respuesta visualizarDocumento', respuesta);
          }
        } catch (err) {
          console.log('visualizarDocumento', err)          
          this.banderaConsultando = false;
          } finally {
          this.banderaConsultando = false;
        }
      }
    },
    components: {
      Icono
    }
  }
</script>

<style lang="scss" src="./TarjetaDescargar.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/DescargarArchivoV2/TarjetaDescargar/TarjetaDescargar.vue